import { uniqBy } from 'lodash-es';

import State from '../../../../core/State';
import {
  CreativeFormat,
  CreativeFormatPlaybackTime,
  OrganizationDetailFragment,
  SupportingCreativeFormatPlaybackTime,
} from '../../../../generated/graphql';
import { getWorkflowSteps as getWorkflowStepsConverter } from '../../../../utility/workflowStepConvert';
import { InputtingCreativeFormat } from '../../../types/InputtingCreativeFormat';
import { InputtingCreativeFormatsFilter } from '../../../types/InputtingCreativeFormatsFilter';

export const getRegion = (lastAccessedOrganization: State['lastAccessedOrganization']) => {
  return lastAccessedOrganization != null && lastAccessedOrganization.businessRegion.key
    ? lastAccessedOrganization.businessRegion.key
    : 'jp';
};

export const getOrganization = (
  lastAccessedOrganization: State['lastAccessedOrganization'],
  availableOrganizations: State['availableOrganizations'],
): OrganizationDetailFragment => {
  return lastAccessedOrganization ? lastAccessedOrganization : availableOrganizations.items[0];
};

export const isPointRequired = (lastAccessedOrganization: State['lastAccessedOrganization']): boolean => {
  return lastAccessedOrganization ? typeof lastAccessedOrganization.pointBalance === 'number' : false;
};

export const getWorkflowSteps = (hasOption: boolean, isFlat: boolean) => {
  // 発注ページのステップが減るので、workflowStepsにも反映させる
  const targetWorkflowSteps = ['due', 'brief'];
  const workflows = getWorkflowStepsConverter(hasOption ? [] : ['option']);
  return isFlat ? workflows.filter((workflowStep) => targetWorkflowSteps.indexOf(workflowStep) === -1) : workflows;
};

export const getInitialSelectedInputtedPlaybackTime = (
  playbackTime: SupportingCreativeFormatPlaybackTime | null | undefined,
  seconds = 15,
): ReadonlyArray<Omit<CreativeFormatPlaybackTime, 'id'>> => {
  if (playbackTime && playbackTime.availables.find((playbackTimeItem) => playbackTimeItem.seconds === seconds))
    return [
      {
        supportingPlaybackTimeId: playbackTime.id,
        requiredOption: playbackTime.availables.find((available) => available.seconds === seconds)!.requiredOption,
        seconds,
      },
    ];
  else if (playbackTime && playbackTime.availables[0])
    return [
      {
        supportingPlaybackTimeId: playbackTime.id,
        requiredOption: playbackTime.availables[0].requiredOption,
        seconds: playbackTime.availables[0].seconds,
      },
    ];
  else return [];
};

export const getUpdatedInputtingCreativeFormatsFilter = (
  inputtingCreativeFormats: ReadonlyArray<InputtingCreativeFormat>,
) => {
  const distinctCreativeNetworksAndPlacements: Array<
    InputtingCreativeFormatsFilter['networksAndPlacements'][number]
  > = [];
  const distinctCreativeTypes: Array<InputtingCreativeFormatsFilter['creativeTypes'][number]> = [];

  inputtingCreativeFormats.forEach((inputtingCreativeFormat) => {
    inputtingCreativeFormat.network.placements.forEach((placement) => {
      distinctCreativeNetworksAndPlacements.push({
        network: inputtingCreativeFormat.network,
        placement,
        selected: false,
      });
    });

    distinctCreativeTypes.push({
      creativeType: inputtingCreativeFormat.creativeType,
      selected: false,
    });
  });

  return {
    networksAndPlacements: uniqBy(distinctCreativeNetworksAndPlacements, 'placement.id'),
    creativeTypes: uniqBy(distinctCreativeTypes, 'creativeType.id'),
  };
};

export const getResizeSortedCreativeFormats = (
  creativeFormats: ReadonlyArray<CreativeFormat>,
): ReadonlyArray<CreativeFormat> => {
  const sortedCreativeFormats: Array<CreativeFormat> = [];
  const resizeCreativeFormats = creativeFormats.filter((creativeFormat) => !!creativeFormat.resizeBaseId);

  creativeFormats.map((creativeFormat) => {
    if (!creativeFormat.resizeBaseId) {
      sortedCreativeFormats.push(creativeFormat);

      resizeCreativeFormats.map((resizeCreativeFormat) => {
        if (resizeCreativeFormat.resizeBaseId === creativeFormat.id) {
          sortedCreativeFormats.push(resizeCreativeFormat);
        }
      });
    }
  });
  return sortedCreativeFormats;
};
